import {
  bootstrapApplication,
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withNoIncrementalHydration
} from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpRequest } from '@angular/common/http';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        filter: (_req: HttpRequest<unknown>) => true,
        includeHeaders: [],
        includePostRequests: true,
        includeRequestsWithAuthHeaders: false,
      }),
      withNoIncrementalHydration(),
    ),
  ],
}).catch((err) => console.error(err));
